import Link from 'next/link';
import Image from 'next/legacy/image';
import { Box, Flex, Heading, Icon, Text } from '@chakra-ui/react';
import { ArrowRightIcon, QuestionMarkCircleIcon } from '@heroicons/react/solid';

const support = [
  {
    title: 'Join our Discord',
    description:
      'Join our official Discord server to chat with us directly and become a part of the Clerk community.',
    url: 'https://discord.com/invite/b5rXHjAg7A',
    ctaText: 'Join Discord',
    logo: '/images/logos/discord.svg'
  },
  {
    title: 'Need help?',
    description:
      'Contact us through Discord, Twitter, or email to receive answers to your questions and learn more about Clerk.',
    url: '/support',
    ctaText: 'Get help',
    icon: QuestionMarkCircleIcon
  }
];

export function Support(): JSX.Element {
  return (
    <Flex pb={12}>
      {support.map(
        ({ title, description, url, ctaText, logo, icon }, index) => {
          const isFirst = index === 0;

          return (
            <Box
              key={title}
              pr={isFirst ? 6 : 0}
              pl={!isFirst ? 6 : 0}
              flex={1}
              borderRight={isFirst ? '1px solid' : 'none'}
              borderColor="var(--borderColor)"
            >
              {logo && (
                <Box mb={4}>
                  <Image
                    src={logo}
                    alt={`${title} logo`}
                    height={24}
                    width={24}
                  />
                </Box>
              )}

              {icon && (
                <Icon as={icon} color="var(--iconColor)" boxSize={6} mb={5} />
              )}

              <Heading
                as="h3"
                size="3xs"
                mb={0.5}
                color="var(--primaryTextColor)"
              >
                {title}
              </Heading>

              <Text
                color="var(--secondaryTextColor)"
                textStyle="xs-normal"
                maxW="60ch"
                mb={4}
              >
                {description}
              </Text>

              <Link legacyBehavior href={url} passHref>
                <Text
                  as="a"
                  color="var(--secondaryTextColor)"
                  textStyle="xs-medium"
                  role="group"
                  _hover={{
                    color: 'var(--secondaryBlue)'
                  }}
                >
                  {ctaText}
                  <Icon
                    as={ArrowRightIcon}
                    ml={1}
                    pos="relative"
                    top="-1px"
                    transition="margin-left .2s"
                    _groupHover={{
                      ml: 2
                    }}
                  />
                </Text>
              </Link>
            </Box>
          );
        }
      )}
    </Flex>
  );
}
